export class HostingBasicInfo {

  public region: string;
  public location: string;
  public ip: string;

}

